<script>
import ModalOverlay from '@/components/modal/ModalOverlay';
import InputBlock from '@/components/InputBlock';
import Button from '@/components/Button';

export default {
  name: 'ModalEnterCode',
  components: {
    Button,
    ModalOverlay,
    InputBlock,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    codeError: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <ModalOverlay>
      <div class="modal__dialog">
        <div class="modal__content">
          <div class="modal__top">
            <div class="modal__title">
              Enter the code
            </div>
            <div class="modal__close" @click="$emit('close')">
              <img :src="require('@/assets/svg/close.svg')" />
            </div>
            <div class="modal__text">
              Please enter the code that we sent you by mail <br />(<span>{{
                email
              }}</span
              >)
            </div>
          </div>
          <div class="modal__middle">
            <InputBlock
              :error="codeError"
              @input="val => $emit('change', val)"
              placeholder="Enter code here…"
            >
              <template #linkBottom>
                <Button class="link-input" @click="$emit('retry')">
                  Send again
                </Button>
              </template>
            </InputBlock>
          </div>
          <div class="modal__bottom">
            <Button class="blue" @click="$emit('action')">
              Send
            </Button>
          </div>
        </div>
      </div>
    </ModalOverlay>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.modal {
  &__dialog {
    padding: 87px 20px 40px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  &__content {
    max-width: 570px;
    border-radius: 36px;
    background-color: #101112;
    border: solid 1px rgba(255, 255, 255, 0.2);
    padding: 0 0 40px;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: #ffffff;
  }

  &__top {
    text-align: center;
    position: relative;
    padding: 40px 0 35px;
    flex-shrink: 0;
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 21px;
    line-height: 29px;
    margin-bottom: 14px;
    color: #ffc107;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 1.86;
    max-width: 420px;
    margin: 0 auto;
    width: 100%;

    span {
      font-family: Poppins-SemiBold;
    }
  }

  &__middle {
    flex-grow: 1;
    text-align: center;
    padding: 0 40px;
  }

  &__bottom {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    margin-top: 70px;
  }

  &__close {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    cursor: pointer;

    img {
      display: flex;
      width: 100%;
      height: 100%;
    }

    &:hover {
      opacity: 0.5;
    }
  }
}

@media (max-width: $mobile) {
  .modal {
    &__top {
      padding-right: 15px;
      padding-left: 15px;
    }

    &__middle {
      padding-right: 15px;
      padding-left: 15px;
    }
  }
}
</style>
